import axios from '../shared/axios';
import * as events from './events';
import SystemHelper from "../shared/systemHelper";

export function saveTaskOrder(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/TaskOrder/SaveTaskOrder`, data)
            .then(result => {
                events.onNotification_CREATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}
export function updateTaskOrder(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/TaskOrder/Update`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                resolve(result);
            })
            .catch(error => reject(error));
    });
}
export function getTaskOrder(taskorderid) {
    return axios.get(`/api/TaskOrder/GetTaskOrder?earlytaskorderid=${taskorderid}`);
}

// export function getTaskOrders(companyid, projectid, contractid, type, accessibleWfIds) {
//     return axios.post(`/api/TaskOrder/LoadTaskOrdersList`, { accessibleWfIds }, { params: { companyid, projectid, contractid, type } });
// }

// export function getTaskOrdersReduced(companyid, projectid, contractid, accessibleWfIds) {
//     return axios.post(`/api/TaskOrder/RegisterList`, { accessibleWfIds }, { params: { companyid, projectid, contractid } });
// }
export function getTaskOrdersReduced2(companyid, projectid, contractid, showDrafts, accessibleWfIds) {
    return axios.post(`/api/TaskOrder/RegisterListV2`, {
        showDrafts: showDrafts,
        showRelations: process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true',
        showTags: process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true',
        showCustomFields: SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.CUSTOM_FIELDS_ENABLED),
        excludeTagHeaders: true,
        accessibleWfIds
    },
        { params: { companyid, projectid, contractid } });
}

export function getTaskOrdersToSelectList(contractid) {
    return axios.get(`/api/TaskOrder/ToSelectList`, { params: { contractid } });
}

export function deleteTaskOrderDraft(taskorderid) {
    return new Promise((resolve, reject) => {
        axios.post(`api/TaskOrder/DeleteDraft?taskorderid=${taskorderid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}

export function importTaskOrders(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/TaskOrder/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteTaskOrderDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/TaskOrder/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateTaskOrderDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/TaskOrder/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}